import { useCreate } from "../../../api/react-query"

export const useUpdateEmpStatus = () => {

    const {mutateAsync: updateEmpStatus, isLoading} = useCreate({
        url: 'employee/empStatus',
        apiVersion: 'v1', 
    });

    return {
        updateEmpStatus,
        isCreating: isLoading
    }
}